import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const alias = "/faq/question-categories";

const getAllCategories = params =>
  ConfigCmsApi.get(alias, {
    params,
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const getCategory = id =>
  ConfigCmsApi.get(`${alias}/${id}`, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const createCategory = request =>
  ConfigCmsApi.post(alias, request, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const updateCategory = (id, request) =>
  ConfigCmsApi.post(`${alias}`, request, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

const deleteCategory = id =>
  ConfigCmsApi.delete(`${alias}/${id}`, {
    headers: {
      Authorization: Cookies.get("adminToken")
    }
  });

export default {
  getAllCategories,
  getCategory,
  createCategory,
  updateCategory,
  deleteCategory
};
